import React, { FC } from 'react';
import cx from 'classnames';

import BarsIcon from 'assets/bars.svg';
import CrossIcon from 'assets/cross.svg';
import FiltersIcon from 'assets/filters.svg';

import styles from './iconButton.module.scss';

type IconName = 'bars' | 'cross' | 'filters';

const iconsList: { [key in IconName]: keyof JSX.IntrinsicElements } = {
  bars: BarsIcon,
  cross: CrossIcon,
  filters: FiltersIcon,
};

interface IProps {
  id?: string;
  className?: string;
  ariaLabel?: string;
  name: IconName;
  onClick: () => void;
}

const IconButton: FC<IProps> = ({
  id,
  className,
  ariaLabel,
  name,
  onClick,
}) => {
  const Icon: keyof JSX.IntrinsicElements = iconsList[name];
  return (
    <button
      id={id}
      type="button"
      className={cx(styles.button, className)}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <Icon
        role="img"
        width="0"
        height="0"
        className={cx(styles.icon, styles[`${name}Icon`])}
      />
    </button>
  );
};

export default IconButton;
